module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgAQMAAABJtOi3AAAABlBMVEUAAAD///+l2Z/dAAAAAXRSTlMAQObYZgAAAC9JREFUCNdjAIP6//8bIEQCAyM2ogeZ+H8QTEC4eGUJECAroQQQ8CARjP///wETANRRLVE0R+/LAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronicDocuments/example_icon.png
// module id = EiEP
// module chunks = 2